import { useInventoryId } from '@/hooks/use-inventory-id';
import { useNow } from '@/hooks/use-now';
import { useGetBaselineQuery } from '@/api/baseline';
import { Loading } from '@/components/loading';
import { Layout } from '@/components/layout';
import { BaselineList } from '@/components/baseline-list';

const Baseline = () => {
  const inventoryId = useInventoryId();
  const now = useNow();
  const { data: baselines, isLoading: isLoadingScenarios } =
    useGetBaselineQuery(inventoryId);
  if (isLoadingScenarios) {
    return <Loading />;
  }
  return (
    <Layout>
      <BaselineList now={now} baseline={baselines ?? []} />
    </Layout>
  );
};

export { Baseline };
